export const snackSaved = 'SnackBars.Saved';
export const passwordReseted = 'SnackBars.PasswordReset';
export const contractorWasSaved = 'SnackBars.ContractorWasSaved';
export const clientWasSaved = 'SnackBars.ClientWasSaved';
export const fileDuplicateFound = 'SnackBars.FileDuplicateFound';
export const errorCreatingOrderWhileSendingFile = 'Errors.AfterCreatingOrderWhileSendingFile';
